import 'twin.macro';
import React from 'react';
import { v4 as uuid } from 'uuid';
import { useCreateFolder } from 'containers/Sequences/queries/useCreateFolder';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Infobox } from 'components/Callout/Infobox';
import Button from 'components/Buttons/Button';
import { FolderIcon, LightBulbIcon } from '@heroicons/react/24/outline';

export function FolderTip() {
  const createFolder = useCreateFolder();
  const navigate = useNavigate();
  const { t } = useTranslation(['sequence']);

  return (
    <Infobox
      intent="primary"
      icon={LightBulbIcon}
      title={t('sequence:sidebar.folderTip.title')}
      tw="mt-10 mb-2 p-2"
    >
      <p tw="mt-2 text-pretty">{t('sequence:sidebar.folderTip.description')}</p>
      <Button
        onClick={() => {
          const newFolderId = uuid();
          return createFolder({
            id: newFolderId,
            name: t('sequence:actions.newFolder'),
          }).then(() => navigate(`/sequences/folders/${newFolderId}?new=true`));
        }}
        intent="primary"
        outlined
        icon={FolderIcon}
        tw="mt-4"
      >
        {t('sequence:sidebar.folderTip.cta')}
      </Button>
    </Infobox>
  );
}
